module.exports = "/images/vendor/flag-icon-css/flags/1x1/vc.svg?bbb52fa0756298590332a07e5d69f2c2";